 <div class="nav-side-menu text-color-2" *ngIf="!notIsLoggedIn">
   <i class="fa fa-bars fa-2x toggle-btn" (click)="toggleCollapsed()"></i>

   <div class="menu-list">
     <div class="hamburger"
          [class.collapsed]="collapsedOnDesktop"
          (click)="collapseOnDesktop()">
       <div></div>
       <div></div>
       <div></div>
     </div>
     <ul id="menu-content"
         [ngClass]="{'collapse': collapsed, 'navbar-collapse': true}"
         [class.collapsed]="collapsedOnDesktop"
         class="menu-content collapse out">

       <li *ngIf="differentLoggedIn">
         <a class="menu-item" (click)="backOriginPage()">
                     <span style="vertical-align: middle;">
                       <i class="fas fa-long-arrow-alt-left"></i>
                       {{backButtonText}}
                     </span>
         </a>
       </li>

       <li [ngClass]="{'selected':currentUrl == menuItem.Path}" *ngFor="let menuItem of menuEntityList"
           (click)="navigateToPage(menuItem)">

         <a class="menu-item">
           <i class="fa menu-icon" [ngClass]="menuIcons[menuItem.PageName]"></i>
           <span style="vertical-align: middle;">{{menuItem.MenuTitle}}</span>
         </a>


       </li>

       <div class="border-top-line" style="margin-top: 22px;">
       </div>

       <li [ngClass]="{'selected':currentUrl == 'profile'}" (click)="navigateToUrl('/profile')">
         <a class="menu-item">
           <i class="fas fa-user menu-icon"></i>
           <span style="vertical-align: middle;">{{profileOwnershipTitle}} {{'PROFILE' | dictionary}}</span>
         </a>
       </li>

       <li (click)="logout()">
         <a class="menu-item">
           <i class="fas fa-sign-out-alt  menu-icon"></i>
           <span style="vertical-align: middle;">{{'LOG_OUT' | dictionary}}</span>
         </a>
       </li>

       <div class="border-top-line">
       </div>

       <li [ngClass]="{'selected':currentUrl == 'faq'}" (click)="openFaq.emit()">
         <a class="menu-item">
           <i class="far fa-question-circle menu-icon"></i>
           <span style="vertical-align: middle;">{{'NEED_HELP' | dictionary}}</span>
         </a>
       </li>
     </ul>
   </div>

 </div>
